module.exports = __webpack_public_path__ + "static/media/rental.d42eba6f.svg";